import { useTranslation } from 'react-i18next'
import React from 'react'

import { getAvailabilityStatusColor } from '../_helpers/getAvailabilityStatusColor'
import Tag from '../../../components/presentation/Tag'

const AvailabilityStatusTag = ({ status, ...props }) => {
  const { t } = useTranslation('availability')
  if (!status) return false

  const color = getAvailabilityStatusColor(status)
  const label = t(`status.${status}`)

  return <Tag label={label} bgColor={color} {...props} />
}

export default AvailabilityStatusTag
